// =============================================================================
// SERVICES — Configuration constants for upstream endpoints
// =============================================================================

export const AUTH_API = 'https://auth-api.arkturian.com';
export const ISSUE_API =
  import.meta.env.VITE_ISSUE_API_BASE || 'https://issue-api.arkturian.com';
export const STORAGE_API =
  import.meta.env.VITE_STORAGE_API_BASE || 'https://api-storage.arkserver.arkturian.com';
export const STORAGE_API_KEY = import.meta.env.VITE_STORAGE_API_KEY || 'Inetpass1';

export const AUTH_STORAGE_KEY = 'ark-auth';
export const AUTH_DISABLED = import.meta.env.VITE_DISABLE_AUTH === 'true';

export const ALLOWED_EMAILS = [
  'apopovic.aut@gmail.com',
  'alex@arkturian.com',
  'wow.wunderwelten@gmail.com',
  'marlon.popovic.aut@gmail.com',
  't.saier@edera-safety.com',
  'jascha@bellevue-living.com',
];
